// extracted by mini-css-extract-plugin
module.exports = {"button":"button-03d28a20","icon-accessability":"icon-accessability-edfa5ecf","iconAccessability":"icon-accessability-edfa5ecf"};